var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalPo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7352 1.84375H7.26128C6.84947 1.84375 6.51562 2.17759 6.51562 2.58941V4.08072C6.51562 4.49254 6.84947 4.82638 7.26128 4.82638H11.7352C12.147 4.82638 12.4809 4.49254 12.4809 4.08072V2.58941C12.4809 2.17759 12.147 1.84375 11.7352 1.84375Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4791 3.33594H13.9705C14.366 3.33594 14.7453 3.49306 15.025 3.77273C15.3047 4.05241 15.4618 4.43173 15.4618 4.82725V14.709C15.4618 15.1046 15.3047 15.4839 15.025 15.7636C14.7453 16.0432 14.366 16.2004 13.9705 16.2004H5.02257C4.62704 16.2004 4.24772 16.0432 3.96805 15.7636C3.68837 15.4839 3.53125 15.1046 3.53125 14.709V4.82725C3.53125 4.43173 3.68837 4.05241 3.96805 3.77273C4.24772 3.49306 4.62704 3.33594 5.02257 3.33594H6.51388",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.662 8.22656L7.70493 12.1837L5.90625 10.385",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.097 9.67188L10.399 12.3699L9.85938 11.8303",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPo);
export default __webpack_public_path__ + "static/media/totalPo.7a2e0a60b24eceac5c4ed7d5e8519993.svg";
export { ForwardRef as ReactComponent };